

export const APP_COMPANY_CONFIG_LS = {

    HAS: {
        HAS__FOOTER_BRAND_POWERED_LS: false,
    },

    TEXT: {
        TEXT__FOOTER_BRAND_POWERED_BY: "Powered by",
        TEXT__FOOTER_BRAND_NAME: "NOTEBOOK",
        TEXT__FOOTER_LINK_REDIRECT: "/",
    }

};